import HelperAndDriverCreate from "../components/views/helperAndDriverManagment/helperAndDriverCreate.vue";
import HelperAndDriver from "../components/views/helperAndDriverManagment/helperAndDriver.vue";
import DutyTracking from "../components/views/helperAndDriverManagment/dutyTracking.vue";

const routes = [
  {
    path: "helperAndDriver",
    component: HelperAndDriver,
    name: "helperAndDriver",
    meta: {
      description: "List of Staffs",
      title: "Staff",
      requiresAuth: true,
    },
  },
  {
    path: "helperAndDriver/helperAndDriverCreate/:_id",
    component: HelperAndDriverCreate,
    name: "helperAndDriverCreate",
    meta: {
      // description: 'Add a new Staff',
      title: "Add / Update Staff Details",
      requiresAuth: true,
    },
  },
  {
    path: "/helperAndDriver/tracking/:_id",
    component: DutyTracking,
    name: "dutyTracking",
    meta: {
      // description: 'Add a new Staff',
      title: "Duty Calendar",
      requiresAuth: true,
    },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/helperAndDriver.route.js